import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AppRouter from "./router/AppRouter";
import ChatbotFAB from "./components/chat/ChatbotFAB";
import ChatbotModal from "./components/chat/ChatbotModal";
import NotesFAB from "./components/notes/NotesFAB";
import SavedNotesModal from "./components/notes/SaveNotesModal";
import MotivationLoader from "./components/loaders/MotivationLoadr";
import FocusTimerFAB from "./components/focus/FocusTimerFAB";
import ProductAnalyticsListener from "./components/analytics/ProductAnalyticsListener";

const AppRoot = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 1rem;
`;

const Main = styled.main`
  flex: 1;
  min-height: 0;
  padding: ${({ $flush }) => ($flush ? "0" : "2rem 0")};
  overflow: ${({ $flush }) => ($flush ? "hidden" : "visible")};
  display: ${({ $flush }) => ($flush ? "flex" : "block")};
  flex-direction: column;

  ${({ $flush }) =>
    $flush &&
    `
      > * {
        flex: 1;
        min-height: 0;
      }
    `}
`;

export default function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const isAIMentorRoute = location.pathname.startsWith("/ai-mentor-chat");
  const showAIAssistant = !isAIMentorRoute;

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(t);
  }, []);

  return (
    <>
      <MotivationLoader visible={loading} />
      {!loading && (
        <AppRoot>
          <ProductAnalyticsListener />
          <Header />
          <Main $flush={isAIMentorRoute}>
            <AppRouter />
          </Main>
          {!isAIMentorRoute && <Footer />}
          {showAIAssistant && <ChatbotFAB />}
          {showAIAssistant && <ChatbotModal />}
          <FocusTimerFAB />
          {!isAIMentorRoute && <NotesFAB />}
          {!isAIMentorRoute && <SavedNotesModal />}
        </AppRoot>
      )}
    </>
  );
}
